import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { CREATE_CHAUFFEUR, CREATE_CHAUFFEUR_ERROR, CREATE_CHAUFFEUR_SUCCESS } from '../../../actions.js';

function* createChauffeur({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/get-dashboard-data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CREATE_CHAUFFEUR_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_CHAUFFEUR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_CHAUFFEUR_ERROR, payload: error });
  }
}

export function* watchCreateChauffeur() {
  yield takeEvery(CREATE_CHAUFFEUR, createChauffeur);
}

function* createChauffeurSaga() {
  yield all([fork(watchCreateChauffeur)]);
}

export default createChauffeurSaga;
